export const locale = {
    lang: "es",
    data: {
        CLIENTS: {
            CLIENTS: "Clientes",
        },
    },
};
